export default "__VITE_ASSET__CrJbp8xX__"